import { useSelector } from "react-redux";

import type { RootState } from "@/types/store";

export const useOrganizationData = () => {
  return useSelector((state: RootState) => state.Organization);
};
